// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "4920" ? "__federation_expose_ActionsGuardrails" : chunkId) + "." + {"2438": "b496478876e9a9eb","4920": "95e38715554742bb",}[chunkId] + ".css"
}